import { Platform } from 'react-native';
import logError from 'src/data/services/logError';
import { useServicesStore } from 'src/domain/stores/useServicesStore';
import { useNotificationStore } from 'src/domain/stores/useNotificationStore';
import { useAppUpdateStore } from 'src/domain/stores/useAppUpdateStore';
import useAppStateGlobalListener from 'src/presentation/hooks/useAppStateGlobalListener';
import AppUpdateDialog from 'src/presentation/dialogs/AppUpdateDialog';

/**
 * A browser has no app store to send the user to, and AppUpdateDialogType falls back to the
 * iOS thresholds off-Android, so on web the settings fetch could resolve a mandatory update
 * and put up a dialog whose only button leads nowhere. The whole store-update flow is
 * therefore native-only.
 */
const isStoreUpdateSupported = Platform.OS !== 'web';

function Updater() {
	const { checkForUpdates } = useServicesStore();
	const { update, isAppUpdateDialogVisible, fetchSettings, setAppUpdateDialogVisible } = useAppUpdateStore();

	useAppStateGlobalListener({
		onInit: async () => {
			await checkForUpdates();
			if (isStoreUpdateSupported) {
				fetchSettings().catch(logError);
			}
		},
		onForegrounded: async () => {
			await checkForUpdates();
			if (isStoreUpdateSupported) {
				fetchSettings().catch(logError);
			}
			// Re-register on foreground so a rotated FCM token reaches the backend.
			useNotificationStore.getState().registerDevice().catch(logError);
		},
	});

	if (!isStoreUpdateSupported || update === null || !isAppUpdateDialogVisible) {
		return null;
	}

	return (
		<AppUpdateDialog isDialogVisible={true} update={update} onCancelPress={() => setAppUpdateDialogVisible(false)} />
	);
}

export default Updater;
